export const BACKEND = "https://api.acr-intranet.com";
